module.exports = __webpack_public_path__ + "img/yt-hero1-2-desktop.1ff33150.png";